import { ValueDefaultFilters } from "./interface";

const ORDER_STATUSES_ENUM = {
	UnclosedOrders: "unclosedOrders",
	CompletedOrders: "completedOrders",
	NoCarAvailable: "noCarAvailable",
	ClientRefusal: "clientRefusal",
	DriverRefusal: "driverRefusal",
	CalculationError: "calculationError",
	DispatcherError: "dispatcherError",
} as const;

const ORDER_STATUSES = Object.values(ORDER_STATUSES_ENUM);

const PAYMENTS_ENUM = {
	Cash: "cash",
	Company_bill: "company_bill",
	Card: "card",
} as const;
const PAYMENTS = Object.values(PAYMENTS_ENUM);
// paymentsOptions
// cash;
// corporate;
// card;

const DEFAUT_VALUEE_FILTERS: ValueDefaultFilters = {
	companyIds: [],
	taxiServiceIds: [],
	taxiServices: [],
	//
	executorIds: [],
	checkBoxExecutorIds: false,
	//
	statusOrder: [],
	checkBoxStatusOrder: false,
	//
	numberOrder: "",
	checkNumberOrder: false,
	//
	numberPhone: "",
	checkNumberPhone: false,
	//
	street: "",
	checkStreet: false,
	//
	agent: [],
	checkAgent: false,
	//
	client: [],
	checkClient: false,
	//
	counterparty: [],
	checkCounterparty: false,
	//
	classes: [],
	checkClasses: false,
	//
	services: [],
	checkServices: false,
	//
	sectors: [],
	checkSectors: false,
	//
	payments: [],
	checkPayments: false,
	//
	transfer: [],
	checkTransfer: false,
	//
	sourceCallSing: [],
	checkSourceCallSing: false,
};

export {
	ORDER_STATUSES_ENUM,
	ORDER_STATUSES,
	PAYMENTS_ENUM,
	PAYMENTS,
	DEFAUT_VALUEE_FILTERS,
};
